// dnAlert — kept as an alias for dnPopup so existing imports keep working.
// All popups are themed div popups. SweetAlert is gone from the app entirely -
// the sign-in page was the last holdout and now uses dAdmin's top-right toast
// stack (utils/dNews_Alert.js) instead.
import dnPopup from "./dnPopup";

const dnAlert = dnPopup;

export default dnAlert;
